import { useRef, useState } from "react";
import { Table, ConfigProvider } from "antd";
import { useBusCoursesQuery } from "src/services/react-query-apis/get-bus-courses";
import ActionButtonGroup from "src/components/common/Button/ActionButtonGroup";
import CourseEditForm from "src/components/admin/busManagement/course-edit-form";
import { useDeleteBusCourseMutation } from "src/services/react-query-apis/delete-bus-course";
import { toast } from "react-toastify";
import { swalConfirm } from "src/utils/swalHelpers";

const customTheme = {
  components: {
    Table: {
      rowHoverBg: "#D6EAF8",
    },
  },
};

const BusCourses = () => {
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const formSubmitRef = useRef();

  const busCoursesQuery = useBusCoursesQuery({});

  const deleteBusCourseMutation = useDeleteBusCourseMutation({
    mutationConfig: {
      onSuccess: async data => {
        toast.success(data.message);
        setSelectedCourseId(null);
      },
    },
  });

  const columns = [
    {
      title: "コースコード",
      dataIndex: "code",
      key: "code",
      width: 100,
      align: "center",
    },
    {
      title: "説明",
      dataIndex: "description",
      key: "description",
    },
  ];

  const rowClassName = record => {
    return selectedCourseId === record.id ? "table-selected-row" : "";
  };

  const selectedCourse = busCoursesQuery.data?.data.find(
    course => course.id === selectedCourseId
  );

  const handleDelete = () => {
    if (selectedCourseId) {
      swalConfirm("このコースを削除してもよろしいですか？").then(willDelete => {
        if (willDelete) {
          deleteBusCourseMutation.mutate(selectedCourseId);
        }
      });
    }
  };

  return (
    <div style={{ width: "65%" }}>
      <div className="card-body">
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              バスコース一覧
            </div>
            <ActionButtonGroup
              storeHandler={() => {
                formSubmitRef.current.click();
              }}
              deleteClasseHandler={handleDelete}
              updateClasseHandler={() => {
                formSubmitRef.current.click();
              }}
              AddBtnEnbl={selectedCourseId === null}
              DltBtnEnbl={selectedCourseId !== null}
              UpdateBtnEnbl={selectedCourseId !== null}
            />
          </div>
          <div className="p-3">
            <CourseEditForm
              key={selectedCourse?.id}
              setSelectedCourseId={setSelectedCourseId}
              selectedCourse={selectedCourse}
              formSubmitRef={formSubmitRef}
            />
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          <ConfigProvider theme={customTheme}>
            <Table
              bordered
              dataSource={busCoursesQuery.data?.data || []}
              columns={columns}
              loading={busCoursesQuery.isLoading}
              rowKey="id"
              pagination={false}
              rowClassName={rowClassName}
              onRow={record => ({
                onClick: () =>
                  setSelectedCourseId(c =>
                    c === record.id ? null : record.id
                  ),
              })}
              locale={{
                emptyText: busCoursesQuery.error
                  ? "コースデータの取得に失敗しました"
                  : "コースデータがありません",
              }}
            />
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

export default BusCourses;
